// extracted by mini-css-extract-plugin
export default {"main":"Main_main__0hbXA","flareAnimation":"Main_flareAnimation__Fqp40"};